module.exports = __webpack_public_path__ + "static/media/local_shipping.e4df09e5.svg";